import { createContext } from "react";

// MainHeader and MainSlider are both wrapped in withRole, which freezes the
// props it receives at mount time (see src/Utils/withRole.tsx) and never
// re-merges them on later renders. Passing the toggle state as a prop through
// that HOC means clicks never visually take effect. Context reads happen
// directly in the consuming component on every render, bypassing that stale
// props snapshot entirely.
function noop() {
  // default context value; HeaderAndSlider always provides a real toggle
}

export const SidebarContext = createContext<{
  open: boolean;
  toggle: () => void;
}>({
  open: false,
  toggle: noop,
});
